<style lang="less">

.wx-fullpage{
    position:relative;
    overflow-y: auto;
    width:100%;
    height:100%;
    padding:15px 0 0;
}
</style>
<template lang="html">
	<div class="wx-fullpage">
		<slot></slot>
	</div>
</template>

<script>

// import pageMaxin from '@components/mixins/page.js';

export default {
	// mixins: [pageMaxin],
    data:function(){
        return {
        }
    },
    components: {

    },
    mounted(){
		
	},
	computed:{

	},
	methods: {

    }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Fullpage.vue